import gsap from 'gsap';
import LocationController from './LocationController';
import LoadingScreen from '../Utils/LoadingScreen';
import Resources from '../Utils/Resources';
import sources from '../sources.js'
import AboutScreen from '../Utils/AboutScreen';

class StateController {
    mapController = null;
    locationController = null;

    menuTriggerEl = null;
    aboutScreenEl = null;
    aboutScreen = null;

    loadingScreenEl = null;
    loadingScreen = null;

    constructor() {
        this.resources = new Resources(sources);
        this.locationController = new LocationController(document.querySelector('canvas.jsLocation'), this, this.resources);

        this.menuTriggerEl = document.querySelector('.jsMenuTrigger');

        this.aboutScreenEl = document.querySelector('.jsAbout');
        if (this.aboutScreenEl) this.aboutScreen = new AboutScreen(this.aboutScreenEl);

        this.loadingScreenEl = document.querySelector('.jsLoader');
        this.loadingScreen = new LoadingScreen(this.loadingScreenEl, this, this.locationController.resources);

        this.initEventListeners();
    }

    initEventListeners() {
        if (this.aboutScreen) {
            this.menuTriggerEl.addEventListener('click', e => {
                e.preventDefault();
                this.aboutScreen.show();
            });
        }
    }

    start() {
        gsap.timeline()
            //.set(this.locationController.canvas, { y: window.innerHeight, transformOrigin: 'center top' })
            .add(() => this.locationController.canvas.classList.add('visible'))

            //.to(this.loadingScreenEl, { duration: 1.3, y: -window.innerHeight, ease: 'power2.inOut' })
            .to(this.loadingScreenEl, { duration: 1.3, opacity: 0, ease: 'power2.inOut' })

            //.to(this.locationController.canvas, { duration: 1.3, y: 0, ease: 'power2.inOut' }, '-=1.3')

            .set(this.loadingScreenEl, { display: 'none' })
        ;
    }
}

export default StateController;